import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";
import TableInput from "./Components/table";
import NewTables from "./Components/newTables";

import label from "./label";
import { retry } from "ckeditor5";

const TEXT = (props) => {
  const {
    field: {
      show_table,
      displayField,
      api,
      apiGet,
      apiDelete,
      apiDisplayFields,
      betChar,
      ...field
    },
    changeTrigger,
    related,
    table,
    defaultValue,
    selectOption,
    api_url,
    setDefaultValues = () => {},
    setData,
    textarea,
    param,
    PUBLIC_API,
    GET_DATA,
    isBulkUpdate,
    removeSelected,
    setDataDelete,
    isDataDelete,
    refID,
    DATA,
  } = props;

  const selectRef = useRef(null);
  const _token = localStorage.getItem("_token");
  const [current, setCurrent] = useState(defaultValue ? defaultValue : null);
  const [fields, setFields] = useState([]);
  const [height, setHeight] = useState(0);
  const [foreignData, setForeignData] = useState([]);
  const [dataShowTable, setDataShowTable] = useState([]);
  const [allFields, setAllFields] = useState([]);
  const [renderTable, setRenderTable] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [refreshModal, setRefreshModal] = useState(0);
  const [callApi, setCallApi] = useState(false);
  const [getValues, setValues] = useState([]);
  const [refreshForm, setRefreshForm] = useState(0);
  const [isUpdate, setIsUpdate] = useState(false);
  const [stateUpdate, setStateUpdate] = useState(false);
  const [isDuplicateData, setDuplicateData] = useState([]);
  const [tempData, setTempData] = useState([]);
  const [isChange, setIsChange] = useState(false);
  const [dataModal, setDataModal] = useState({
    data: [],
    state: "",
  });
  const { proxy, lang, pages, functions, database } = useSelector(
    (state) => state
  );
  const { filterData } = functions;
  const [relatedTable, setRelatedTable] = useState({});
  const [pk, setPK] = useState(undefined);

  // console.log("data field",field.id)
  const [startIndex, setStartIndex] = useState(0);

  const { foreign_keys } = table;
  useEffect(() => {
    if (apiGet) {
      fetch(`${proxy()}${apiGet.api_detail.url}/${param}`, {
        headers: {
          Authorization: _token,
          "content-type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          const { success, data, DisplayFields, FIELDS } = res;
          if (success) {
            setDuplicateData(data);
          }
        });
    }
  }, [apiGet, param]);

  useEffect(() => {
    if (api) {
      const tableId = api?.api_detail?.tables?.[0];
      const mappedData = [];

      pages.map((page) => {
        page.children.map((child) => {
          child.component.map(({ props }) => {
            const findId = props.source?.tables?.find(
              (item) => item.id === tableId
            );
            if (findId) {
              mappedData.push({
                ...findId,
                page_id: child.page_id,
                api_id: props?.buttons?.add?.api?.api_id,
              });
            }
          });
        });
      });

      fetch(`${proxy()}/apis/api/${mappedData?.[0]?.api_id}/input_info`, {
        headers: {
          Authorization: _token,
          "content-type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          setDefaultValues(res.data.display_fields);
        });
    }
  }, [api]);

  const corespondingKey = foreign_keys.find((key) => key.field_id == field.id);
  useEffect(() => {
    const key = isFieldForeign();
    const { foreign_keys } = table;
    const corespondingKey = foreign_keys.find(
      (key) => key.field_id == field.id
    );
    if (defaultValue !== undefined) {
      if (key) {
        const dataBody = {
          table_id: corespondingKey.table_id,
          start_index: startIndex,
          criteria: {},
          exact: true,
        };

        fetch(`${proxy()}/api/foreign/data`, {
          method: "POST",
          headers: {
            Authorization: _token,
            "content-type": "application/json",
          },
          body: JSON.stringify(dataBody),
        })
          .then((res) => res.json())
          .then((res) => {
            const { success, data, fields, sumerize, statistic } = res;

            setForeignData(data);
            setFields(fields);

            const { ref_field_id } = key;
            const primaryField = fields.find(
              (field) => field.id == ref_field_id
            );
            if (primaryField) {
              setPK(primaryField.fomular_alias);
            }
          });
      } else {
        setCurrent(defaultValue);
      }
    } else {
      // if (!isFieldForeign() && field.AUTO_INCREMENT) {
      //     fetch(`${proxy()}/apis/field/autoid/${field.id}`)
      //         .then(res => res.json()).then(res => {
      //             const { data } = res;
      //             // console.log(data.id)
      //             setCurrent(data.id)
      //             changeTrigger(field, data.id)
      //         })
      // } else {
      const key = isFieldForeign();
      if (key) {
        if (foreignData.length == 0) {
          const dataBody = {
            table_id: corespondingKey.table_id,
            start_index: startIndex,
            criteria: {},
          };
          console.log("EFFECT AT 89");
          // console.log(69, dataBody)
          fetch(`${proxy()}/api/foreign/data`, {
            method: "POST",
            headers: {
              Authorization: _token,
              "content-type": "application/json",
            },
            body: JSON.stringify(dataBody),
          })
            .then((res) => res.json())
            .then((res) => {
              const { success, data, fields, sumerize, statistic } = res;
              // console.log(82, res)
              setForeignData([
                ...(data?.filter((record) => record !== undefined) || []),
              ]);
              setFields(fields);
              const { ref_field_id } = key;
              const primaryField = fields?.find(
                (field) => field.id == ref_field_id
              );
              if (primaryField) {
                setPK(primaryField.fomular_alias);
              }
            });
        }
      }
      // }
    }
    // if (defaultValue) {
    //   setValues(
    //     Array.isArray(defaultValue)
    //       ? defaultValue.map((item) => ({
    //           value: item,
    //           label: item,
    //         }))
    //       : []
    //   );
    // }
  }, [defaultValue]);

  const [selectedValue, setSelectedValue] = useState([]);

  const [loadedRecordCount, setLoadedRecordCount] = useState(0);
  const [options, setOption] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [dataForegin, setDataForegin] = useState([]);
  const [dataSearch, setDataSearch] = useState([]);
  const [dataChange, setChangeData] = useState([]);

  useEffect(() => {
    if (selectedValue && callApi) {
      let searchUrl = null;
      let pageUrl = null;
      let allData = null;
      pages.map((page) => {
        page.children.map((child) => {
          child.component.map(({ props }) => {
            const findId = props.source?.tables?.find(
              (item) => item?.primary_key[0] === corespondingKey?.ref_field_id
            );
            if (findId) {
              searchUrl = props.source.search.url;
              pageUrl = props.source.get.url;
              allData = child;
            }
          });
        });
      });
      setDataForegin(allData);
      if (pageUrl || searchUrl) {
        const callApiSearch = () => {
          let criteria = {};
          criteria[pk] = current && current.length > 0 ? current : "";

          if (selectedValue && selectedValue.length) {
            selectedValue.map((item) => {
              if (item?.value) {
                // criteria[pk] = item.value[pk]
                criteria["details.delivery_detail_id"] =
                  item.value["deliveryDetailId"];
                criteria["details.mathanhpham"] = item.value["mathanhpham"];
              }
            });
          }
          const findMSP =
            Array.isArray(selectedValue) &&
            selectedValue?.map(({ value }) => {
              const i = current.find((i) => value[pk] === i);
              if (i) {
                return value["msp"] || value["28MSP"];
              }
            });
          const searchBody = {
            criteria: criteria,
            start_index: 0,
            require_count: false,
            require_statistic: false,
            // isRegexSearching,
            // sort,
            criteria_type: {
              [pk]: "regex",
              "28MSP": "regex",
              "details.delivery_detail_id": "regex",
              "details.mathanhpham": "regex",
            },
            MSP: findMSP,
          };
          const endpoint = apiDisplayFields?.value
            ? apiDisplayFields?.value
            : `/api/PXK/optionLGH`;
          //${searchUrl}\\${window.location.search
          fetch(`${proxy() + endpoint}`, {
            method: "POST",
            headers: {
              Authorization: _token,
              "content-type": "application/json",
            },
            body: JSON.stringify(searchBody),
          })
            .then((res) => res.json())
            .then((res) => {
              const { success, data, DisplayFields, fields } = res;

              if (success) {
                if (data) {
                  if (Array.isArray(selectedValue)) {
                    const filteredData = data
                      .filter((d) =>
                        selectedValue.some(
                          (item) =>
                            item.value["2MLXH"] === d["2MLXH"] &&
                            item?.value?.deliveryDetailId ===
                              d?.deliveryDetailId
                        )
                      )
                      .filter(Boolean);

                    changeTrigger(filteredData);
                  }
                  // console.log("HOLAAA", filteredData);
                }

                // console.log("filtersedDatazzz", filteredData);
                if (removeSelected) {
                  removeSelected.current = dataSearch;
                }
                if (getValues.length > 0) {
                  let newData = [];
                  data.map((item) => {
                    for (const k in item) {
                      const findItem = selectedValue.find(
                        ({ label }) => label === item[k]
                      );
                      if (findItem) {
                        newData.push(item);
                        break;
                      }
                    }
                  });

                  if (newData && newData.length > 0) {
                    setDataSearch(newData);
                  } else {
                    setDataSearch([]);
                    setValues([]);
                  }
                } else if (selectedValue && selectedValue.length > 0) {
                  const newData = data.filter((item) =>
                    selectedValue.some(
                      ({ value }) =>
                        item["2MLXH"] === value["2MLXH"] &&
                        item?.deliveryDetailId === value?.deliveryDetailId
                    )
                  );

                  setDataSearch((prev, _index) => {
                    const newPrev = [...prev];
                    newData.map((newItem) => {
                      const exists = newPrev.some(
                        (prevItem) =>
                          prevItem._id === newItem._id &&
                          prevItem?.deliveryDetailId ===
                            newItem?.deliveryDetailId
                      );

                      if (!exists) {
                        const lastItem =
                          selectedValue[selectedValue.length - 1];

                        newPrev.push({
                          ...newItem,
                          label: lastItem.label,
                          value: lastItem.value,
                        });
                      }
                    });
                    // setChangeData(newPrev);
                    return newPrev;
                  });
                } else {
                  setDataSearch([]);
                }
              } else {
                setDataSearch([]);
              }
            });
        };
        const callApiView = () => {
          fetch(`${proxy()}${pageUrl}`, {
            headers: {
              Authorization: _token,
              "content-type": "application/json",
            },
          })
            .then((res) => res.json())
            .then((res) => {
              const { success, data, DisplayFields, FIELDS } = res;
              setAllFields(FIELDS);
              setDataShowTable(DisplayFields);
            });
        };
        // if (!allFields.length && !dataShowTable.length) {
        callApiView();
        // }
        callApiSearch();
      }
    }
  }, [selectedValue, callApi, showModal, isUpdate, stateUpdate]);

  // const filterData = (data, search) => {
  //   search = normalizeStringAccent(search);

  //   const filteredOptions = data.options.filter((item) => {
  //     item.label = normalizeStringAccent(item.label);
  //     return item.label.toLowerCase().includes(search.toLowerCase());
  //   });

  //   return {
  //     ...data,
  //     options: filteredOptions,
  //   };
  // };

  const loadOptions = async (page = 0, search = "") => {
    return new Promise(async (resolve, reject) => {
      let dataBody = {
        table_id: corespondingKey?.table_id,
        start_index: page,
        type: "or",
      };
      let newData = {
        options: [],
        hasMore: false,
        additional: {
          page: 0,
        },
      };
      const criteria = {};
      const criteria_type = {};

      if (search && search.trim() !== "") {
        if (!displayField?.length) {
          criteria[pk] = search.trim();
        }
        for (const k in displayField) {
          criteria[displayField[k].value] = search.trim();

          criteria_type[displayField[k].value] =
            displayField[k]?.type.value || "regex";
          if (apiDisplayFields) {
            criteria_type["28MSP"] = "regex";
            criteria["28MSP"] = search.trim();
          }
        }

        dataBody.criteria = criteria;
        dataBody["criteria_type"] = criteria_type;
      }

      const promises = [];
      if (apiDisplayFields) {
        const endpoint = apiDisplayFields?.value
          ? apiDisplayFields?.value
          : `/api/PXK/optionLGH`;
        promises.push(
          fetch(`${proxy() + endpoint}`, {
            method: "POST",
            headers: {
              Authorization: _token,
              "content-type": "application/json",
            },
            body: JSON.stringify({
              ...dataBody,
              skip: page,
              limit: 100,
            }),
          })
        );
      } else {
        promises.push(
          fetch(`${proxy()}/api/foreign/data`, {
            method: "POST",
            headers: {
              Authorization: _token,
              "content-type": "application/json",
            },
            body: JSON.stringify(dataBody),
          })
        );
      }

      const responses = await Promise.all(promises);
      const results = await Promise.all(responses.map((res) => res?.json()));
      const res1 = results.length > 1 ? results[0] : { data: [] };
      const res2 = results.length > 1 ? results[1] : results[0];

      const returnedData =
        res2 &&
        res2?.data?.map((item2) => {
          const matchedItem =
            res1.data.find((item1) => item1.id === item2.id) || {};
          return {
            ...matchedItem,
            ...item2,
          };
        });

      // : [...res1.data, ...res2.data];
      // const res = await response.json();
      // = mergedData;
      const dataWithoutNull =
        returnedData?.filter((record) => {
          if (record === null || record === undefined) return false;
          const isDuplicate =
            isDuplicateData &&
            isDuplicateData.length > 0 &&
            isDuplicateData.some((item) => record[pk] === item[pk]);

          return !isDuplicate;
        }) || [];
      setForeignData(dataWithoutNull);
      setLoadedRecordCount((prevCount) => prevCount + dataWithoutNull.length);

      let hasMoreValue = true;

      if (!returnedData?.length) {
        hasMoreValue = false;
      }
      const options = dataWithoutNull.flatMap((item) => {
        const hasArrayField = displayField?.find?.((field) =>
          Array.isArray(item[field.value])
        )?.value;

        if (!hasArrayField) {
          const label =
            Array.isArray(displayField) && displayField.length > 0
              ? displayField
                  .map((field) => item[field.value])
                  .filter(Boolean)
                  .join("|")
              : item[pk];

          return [
            {
              label,
              value: item,
            },
          ];
        }

        const arrayField = hasArrayField;
        const arrayValues = item[arrayField];

        return arrayValues.map((val) => {
          const clonedItem = {
            ...item,
            "22MSP": item?.["28MSP"],
            [arrayField]: val,
          };

          const label =
            Array.isArray(displayField) && displayField.length > 0
              ? displayField
                  .map((field) => clonedItem[field.value])
                  .filter(Boolean)
                  .join("|")
              : item[pk];

          return {
            label,
            value: clonedItem,
          };
        });
      });
      // const options = dataWithoutNull.map((d) => {
      //   if (displayField?.length) {
      //     let label = displayField
      //       .map(({ value }) => d[value])
      //       .filter(Boolean)
      //       .join(betChar ? betChar : "|");
      //     return {
      //       value: d,
      //       label: label,
      //     };
      //   }
      //   return {
      //     value: d,
      //     label: d[pk],
      //   };
      // });

      setOption(options);
      if (defaultValue) {
        const foundOption = options.find(
          (option) => option.value === JSON.stringify(defaultValue)
        );
        if (foundOption) {
          setSelectedOption(foundOption);
        }
      }
      // const filterOpt = options.filter(
      //   (item) =>
      //     !selectedValue.some((selected) => selected.label === item.label)
      // );
      let newOpts = [];
      if (selectedValue && selectedValue.length > 0) {
        const selectedLabelsSet = new Set(
          selectedValue.map((selected) => selected.label)
        );
        const filteredOptions = options.filter((item) => {
          return !selectedLabelsSet.has(item.label);
        });
        if (filteredOptions && filteredOptions.length > 0) {
          newOpts = filteredOptions;
        }
      }
      const mappedOpts = newOpts.length > 0 ? newOpts : options;
      const pageNum = apiDisplayFields ? 100 : 15;

      newData = {
        options: mappedOpts,
        hasMore: hasMoreValue,
        additional: {
          page: hasMoreValue ? page + pageNum : page,
        },
      };
      setTimeout(() => {
        resolve(newData, search);
      }, 100);
    });
  };

  const isFieldForeign = () => {
    if (table) {
      const { foreign_keys } = table;
      const key = foreign_keys.find((key) => key.field_id == field.id);
      if (key) {
        return key;
      }
    }
    return false;
  };

  const isPrimaryKey = () => {
    if (table) {
      const { primary_key } = table;
      const key = primary_key.find((key) => key == field.id);
      if (key) {
        return key;
      }
    }
    return false;
  };

  const fieldChangeData = (values) => {
    const selectedValues = [];
    if (Array.isArray(values)) {
      values.map((item) => {
        // const rawJSON = item.value;
        // const value = rawJSON;
        // if (value[pk]) {
        //   selectedValues.push(value[pk]);
        // }
        const rawJSON = item?.value ? item?.value : item;
        const value = rawJSON?.[pk];
        if (value) {
          selectedValues.push(value);
        }
      });
      setCurrent(selectedValues);
      changeTrigger(field, selectedValues);
    } else {
      setCurrent(values?.value[pk]);
      changeTrigger(field, values?.value[pk]);
    }
  };

  const changeRawData = (e, alias, index) => {
    const { value } = e.target;
    // if (e.keyCode === 13 || e.keyCode === 8) {
    //   setCurrent(value);
    //   if (Array.isArray(alias)) {
    //     changeTrigger(alias, "", index);
    //   } else {
    //     changeTrigger(alias || field, "");
    //   }
    // } else {
    setCurrent(value);
    if (Array.isArray(alias)) {
      changeTrigger(alias, value, index);
    } else {
      changeTrigger(alias || field, value);
    }
    // }
  };

  const focusTrigger = () => {
    setHeight(250);
  };

  const generateData = (data) => {
    // console.log(data)
    // console.log(pk)
    if (pk && data) {
      return data[pk];
    }
    return null;
  };

  // const dataClickedTrigger = (data) => {
  //     setCurrent(data);
  //     changeTrigger(field, data[pk])
  // }changeRawData

  const handleChange = (option, isUpdate, isDataModal) => {
    if (!isUpdate) {
      setCallApi(true);
      setSelectedValue(option);
      fieldChangeData(option);
    } else {
      setCallApi(true);
      setSelectedValue((prev) => {
        if (Array.isArray(prev)) {
          const index = prev.findIndex((item) => item?.label === option?.label);
          if (index !== -1) {
            const updatedValues = [...prev];
            updatedValues[index] = option;
            return updatedValues;
          } else {
            if (isDataModal) {
              return [option];
            } else {
              return [...prev, option];
            }
          }
        } else {
          let newPrev = [{ ...prev }];
          const index = newPrev.findIndex(
            (item) => item.label === option.label
          );

          if (index !== -1) {
            newPrev[index] = option;
            return newPrev;
          } else {
            return [...newPrev, option];
          }
        }
      });
      fieldChangeData([option]);
    }
  };

  const [isLoading, setIsLoading] = useState(false);

  const handleScrollToBottom = () => {
    if (!isLoading) {
      setIsLoading(true);
      // console.log("Reached bottom!");
      setStartIndex((prevIndex) => prevIndex + 1);
    }
  };

  // console.log(JSON.stringify(defaultValue))
  const [defaultOption, setDefaultOption] = useState(null);

  const [initialValue, setInitialValue] = useState(null);
  // console.log(defaultOption)
  useEffect(() => {
    const fetchDataForDefaultValue = async () => {
      const { foreign_keys } = table;
      const corespondingKey = foreign_keys.find(
        (key) => key.field_id == field.id
      );
      if (corespondingKey) {
        const dataBody = {
          table_id: corespondingKey.table_id,
          start_index: 0,
          require_count: false,
          //  exact: true
        };
        const criteria = {};
        criteria[pk] = defaultValue;
        dataBody.criteria = criteria;
        // console.log(290, dataBody)
        console.log("EFFECT AT 292");
        const response = await fetch(`${proxy()}/api/foreign/data`, {
          method: "POST",
          headers: {
            Authorization: _token,
            "content-type": "application/json",
          },
          body: JSON.stringify(dataBody),
        });
        const res = await response.json();
        let returnedData = res.data;

        const foundData = returnedData?.find(
          (d) =>
            d != undefined &&
            (Array.isArray(defaultValue)
              ? defaultValue.includes(d[pk])
              : d[pk] === defaultValue)
        );

        const label = generateData(foundData);
        if (foundData) {
          const dataOption = {
            value: JSON.stringify(foundData),
            label: generateData(foundData),
            fomular_alias: "",
          };
          if (displayField?.length) {
            let fomular_alias = "";
            let label = displayField
              .map(({ value }) => {
                fomular_alias = value;
                return foundData[value];
              })
              .join(betChar ? betChar : "|");

            dataOption.label = label;
          }
          setDefaultOption(dataOption);
          if (defaultValue) {
            setSelectedValue(dataOption);
          }
        }
      }
    };
    if (current !== undefined) {
      fetchDataForDefaultValue();
    }
  }, [defaultValue, pk]);
  // console.log(pk)

  if (isPrimaryKey()) {
    if (!isFieldForeign()) {
      return (
        <div class="row justify-content-center">
          <div class="col-md-8">
            <form>
              <div class="form-group">
                <label for="name">
                  {field?.title?.content || field.field_name}
                  {!field.NULL && <span style={{ color: "red" }}> *</span>}
                </label>
                {/* <input
                                    type={field.AUTO_INCREMENT ? "text" : "number"}
                                    className="form-control"
                                    placeholder=""
                                    onChange={changeRawData}
                                    defaultValue={defaultValue == undefined ? current : defaultValue}
                                    readOnly={field.AUTO_INCREMENT ? true : false}
                                /> */}

                <input
                  type="text"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                  className="form-control"
                  onChange={changeRawData}
                  defaultValue={
                    defaultValue == undefined ? current : defaultValue
                  }
                />
              </div>
            </form>
          </div>
        </div>
      );
    } else {
      if (selectOption) {
        return (
          <div class="row justify-content-center">
            <div class="col-md-8">
              <form>
                <div class="form-group">
                  <label for="name">
                    {field?.title?.content || field.field_name}
                    {!field.NULL && <span style={{ color: "red" }}> *</span>}
                  </label>

                  <AsyncPaginate
                    placeholder={lang["select value"]}
                    loadOptions={loadOptions}
                    onChange={handleChange}
                    isSearchable={true}
                    value={selectedValue}
                    styles={{
                      menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "300px",
                      }),
                    }}
                    additional={{
                      page: 0,
                    }}
                    allowCreateWhileLoading={false} // Không cho phép tạo mới khi đang tải dữ liệu
                  />
                </div>
              </form>
            </div>
          </div>
        );
      } else {
        return (
          <div class="row justify-content-center">
            <div class="col-md-8">
              <form>
                <div class="form-group">
                  <label for="name">
                    {field?.title?.content || field.field_name}
                    {!field.NULL && <span style={{ color: "red" }}> *</span>}
                  </label>
                  <input
                    type={field.AUTO_INCREMENT ? "text" : "number"}
                    className="form-control"
                    placeholder=""
                    onChange={changeRawData}
                    defaultValue={
                      defaultValue == undefined ? current : defaultValue
                    }
                    onKeyDown={changeRawData}
                    readOnly={field.AUTO_INCREMENT ? true : false}
                  />
                </div>
              </form>
            </div>
          </div>
        );
      }
    }
  } else {
    if (!isFieldForeign()) {
      return (
        <div class="row justify-content-center">
          <div class="col-md-8">
            <form>
              <div class="form-group">
                <label for="name">
                  {field?.title?.content || field.field_name}
                  {!field.NULL && <span style={{ color: "red" }}> *</span>}
                </label>
                {textarea ? (
                  <textarea
                    className="form-control"
                    onChange={changeRawData}
                    rows={5}
                    defaultValue={
                      defaultValue == undefined ? current : defaultValue
                    }
                    onKeyDown={changeRawData}
                  ></textarea>
                ) : (
                  <input
                    type={field.AUTO_INCREMENT ? "text" : "number"}
                    className="form-control"
                    placeholder=""
                    onChange={(e) => changeRawData(e)}
                    defaultValue={
                      defaultValue == undefined ? current : defaultValue
                    }
                    onKeyDown={changeRawData}
                    // readOnly={field.AUTO_INCREMENT ? true : false}
                  />
                )}
              </div>
            </form>
          </div>
        </div>
      );
    } else {
      const handleShowTable = () => {
        setShowModal(true);
        setRenderTable(false);
        setRefreshModal((prev) => prev + 1);
        // if (dataSearch && dataSearch.length > 0) {
        //   setShowModal(true);
        // } else {
        //   setShowModal(false);
        //   Swal.fire({
        //     title: lang["fail"],
        //     text: `${field?.title?.content || field.field_name} ${
        //       lang["ERROR3"]
        //     }`,
        //     icon: "error",
        //   });
        // }
      };
      const customComponents = {
        MultiValueRemove: () => null,
      };

      return (
        <>
          <div className="row justify-content-center">
            <div className="col-md-8">
              <form>
                <div className="form-group">
                  <label>
                    {/* change field.field_name */}
                    {field?.title?.content || field.field_name}
                    {!field.NULL && <span style={{ color: "red" }}> *</span>}
                  </label>
                  <div className="d-flex align-items-center">
                    <AsyncPaginate
                      placeholder={lang["select value"]}
                      key={
                        selectedValue && selectedValue.length
                          ? selectedValue.length
                          : 0
                      }
                      loadOptions={async (search, loadedOptions, { page }) => {
                        return await loadOptions(page, search);
                      }}
                      onChange={(opt) => handleChange(opt, false)}
                      isSearchable={true}
                      // isClearable={true}
                      onKeyDown={(e) => {
                        const inputValue = e.target.value;
                        if (
                          api &&
                          (e.key === "Backspace" || e.key === "Delete") &&
                          !inputValue &&
                          selectedValue.length > 0
                        ) {
                          e.preventDefault();
                        }
                      }}
                      value={
                        // selectedValue
                        getValues.length > 0 ? getValues : selectedValue
                        // ? selectedValue
                        // : defaultValue
                      }
                      // components={customComponents}
                      styles={{
                        container: (base) => ({
                          ...base,
                          width: "100%",
                        }),
                        menuList: (base) => ({
                          ...base,
                          maxHeight: "300px",
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      additional={{
                        page: 0,
                      }}
                      isClearable={true}
                      components={
                        api
                          ? {
                              DropdownIndicator: () => null,
                              ClearIndicator: () => null,
                              MultiValueRemove: () => null,
                            }
                          : undefined
                      }
                      isMulti={api ? true : false}
                      noOptionsMessage={() => (
                        <div style={{ fontWeight: "300" }}>
                          {lang["not found data"]}
                        </div>
                      )}
                    />
                    {show_table && show_table.length > 0 ? (
                      <p
                        className="btn btn-success mt-0 ml-3"
                        onClick={handleShowTable}
                        data-toggle="modal"
                        data-target="#renderTable"
                      >
                        {lang["add"]}
                      </p>
                    ) : null}
                  </div>
                  {show_table && show_table.length > 0 ? (
                    <TableInput
                      apiGet={apiGet}
                      field={field}
                      allFields={allFields}
                      showFields={show_table}
                      dataShowTable={dataShowTable}
                      dataSearch={dataSearch}
                      setDataSearch={setDataSearch}
                      dataForegin={dataForegin}
                      changeRawData={changeRawData}
                      selectedValue={selectedValue}
                      fieldChangeData={fieldChangeData}
                      setData={setData}
                      setChangeData={setChangeData}
                      dataChange={dataChange}
                      getValues={getValues}
                      loadOptions={loadOptions}
                      handleChange={handleChange}
                      setSelectedValue={setSelectedValue}
                      setIsUpdate={setIsUpdate}
                      setStateUpdate={setStateUpdate}
                      param={param}
                      PUBLIC_API={PUBLIC_API}
                      GET_DATA={GET_DATA}
                      isBulkUpdate={isBulkUpdate}
                      changeTrigger={changeTrigger}
                      setDataDelete={setDataDelete}
                      refID={refID}
                    />
                  ) : null}
                </div>
              </form>
            </div>
          </div>
          {showModal ? (
            <div
              key={refreshModal}
              class="modal fade"
              id="renderTable"
              tabindex="-1"
              aria-labelledby="renderTable"
              aria-hidden="true"
              data-backdrop="static"
            >
              <div className="modal-dialog" key={refreshForm}>
                <div className="modal-content custome">
                  <div className="modal-header justify-content-start">
                    <span style={{ fontSize: "18px" }}>Thêm</span>
                    {/* <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      onClick={() => setShowModal(false)}
                    >
                      &times;
                    </button> */}
                  </div>
                  <div
                    className="modal-body"
                    style={{
                      height: "70vh",
                      overflowY: "auto",
                      overflowX: "unset",
                    }}
                  >
                    <div style={{ padding: "5px 5em" }}>
                      <label className="form-label">
                        {field?.title?.content || field.field_name}
                      </label>
                      <div className="d-flex align-items-center mb-3">
                        <AsyncPaginate
                          placeholder={lang["select value"]}
                          // key={selectedValue.length}
                          loadOptions={async (
                            search,
                            loadedOptions,
                            { page }
                          ) => {
                            return await loadOptions(page, search);
                          }}
                          onChange={(opt) => {
                            handleChange(opt, true);
                            setIsChange(true);
                            setTempData((prev) => [...prev, opt]);
                            // setSelectedValue((prev) => [...prev, opt]);
                          }}
                          isSearchable={true}
                          // value={selectedValue ? selectedValue : getValues}
                          styles={{
                            container: (base) => ({
                              ...base,
                              width: "100%",
                            }),
                            menuList: (base) => ({
                              ...base,
                              maxHeight: "300px",
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          additional={{
                            page: 0,
                          }}
                          // isMulti={api ? true : false}
                          noOptionsMessage={() => (
                            <div style={{ fontWeight: "300" }}>
                              {lang["not found data"]}
                            </div>
                          )}
                        />
                      </div>
                    </div>
                    <TableInput
                      apiGet={apiGet}
                      field={field}
                      allFields={allFields}
                      showFields={show_table}
                      dataShowTable={dataShowTable}
                      dataSearch={dataSearch}
                      setDataSearch={setDataSearch}
                      dataForegin={dataForegin}
                      changeRawData={changeRawData}
                      selectedValue={selectedValue}
                      setData={setData}
                      showModal={showModal}
                      setChangeData={setChangeData}
                      dataChange={dataChange}
                      loadOptions={loadOptions}
                      handleChange={handleChange}
                      setSelectedValue={setSelectedValue}
                      setIsUpdate={setIsUpdate}
                      setStateUpdate={setStateUpdate}
                      isBulkUpdate={isBulkUpdate}
                      param={param}
                      PUBLIC_API={PUBLIC_API}
                      GET_DATA={GET_DATA}
                      getValues={getValues}
                      setRenderTable={setRenderTable}
                      setRefreshForm={setRefreshForm}
                      pk={pk}
                      displayField={displayField}
                      setDataDelete={setDataDelete}
                      isDataDelete={isDataDelete}
                      changeTrigger={changeTrigger}
                      refID={refID}
                      stateCheck={true}
                    />
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                      onClick={() => {
                        // handleChange(null, true, true);
                        // setData([])
                        // setRenderTable(false);
                        setShowModal(false);
                        // if (isChange) {
                        //   setSelectedValue((prev) => {
                        //     const lastItem = dataSearch[dataSearch.length - 1];
                        //     const filterPrev = prev.filter(
                        //       (select) => select.label !== lastItem.label
                        //     );
                        //     // if (filterPrev) {
                        //     //   return filterPrev;
                        //     // }
                        //     setChangeData((prev) =>
                        //       prev.filter(
                        //         (item) => item.label !== lastItem.label
                        //       )
                        //     );

                        //     return filterPrev;
                        //   });
                        //   refID.current = dataSearch[dataSearch.length - 1]._id;
                        // }

                        if (tempData.length > 0) {
                          const filteredData = selectedValue.filter(
                            (item) =>
                              !tempData.some(
                                (temp) => temp.label === item.label
                              )
                          );
                          const filteredDataSearch = dataChange.filter(
                            (item) =>
                              !tempData.some(
                                (temp) => temp.label === item.label
                              )
                          );

                          setChangeData(filteredDataSearch);
                          // setDataSearch([]);
                          setData((prev) => {
                            prev[field.id] = filteredDataSearch;
                            return prev;
                          });
                          setSelectedValue(filteredData);
                        }
                        setRefreshForm((prev) => prev + 1);
                        setIsChange(false);
                      }}
                    >
                      {lang["btn.close"]}
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary"
                      data-dismiss="modal"
                      onClick={() => {
                        setShowModal(false);
                        setRenderTable(true);
                        setIsChange(false);
                        setTempData([]);
                        setRefreshForm((prev) => prev + 1);
                      }}
                    >
                      {lang["btn.update"]}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </>
      );
    }
  }
};
export default TEXT;
